

// import i18n from 'i18next';
// import { initReactI18next } from 'react-i18next';
// import LanguageDetector from 'i18next-browser-languagedetector';

// i18n
//   .use(LanguageDetector)
//   .use(initReactI18next)
//   .init({
//     fallbackLng: 'en',
//     interpolation: {
//       escapeValue: false,
//     },
//     resources: {
//       en: {
//         translation: {
//           helpCenter: 'Partner Help Center',
//           faq: 'Frequently asked questions',
//           videos: 'How-to videos',
//           portal: 'Partner Portal',
//           contact: 'Contact us',
//           banner: {
//             title: {
//               line1: 'Need help?',
//               line2: "We're here for",
//               line3: 'you.',
//             },
//             subtitle: 'Search our knowledge base for answers to common questions',
//             searchPlaceholder: 'Enter a search term ...',
//           }
//         },
//       },
//       ru: {
//         translation: {
//           helpCenter: 'Центр помощи партнёров',
//           faq: 'Часто задаваемые вопросы',
//           videos: 'Обучающие видео',
//           portal: 'Портал партнёра',
//           contact: 'Связаться с нами',
//           banner: {
//             title: {
//               line1: 'Нужна помощь?',
//               line2: 'Мы рядом, чтобы',
//               line3: 'помочь.',
//             },
//             subtitle: 'Ищите ответы в нашей базе знаний',
//             searchPlaceholder: 'Введите поисковый запрос...',
//           }
//         },
//       },
//       tr: {
//         translation: {
//           helpCenter: 'Ortak Yardım Merkezi',
//           faq: 'Sık sorulan sorular',
//           videos: 'Nasıl yapılır videoları',
//           portal: 'İş Ortağı Portalı',
//           contact: 'Bize ulaşın',
//           banner: {
//             title: {
//               line1: 'Yardıma mı ihtiyacınız var?',
//               line2: 'Biz buradayız',
//               line3: 'sizin için.',
//             },
//             subtitle: 'Sık sorulan sorulara yanıtlar için bilgi tabanımızda arayın',
//             searchPlaceholder: 'Bir arama terimi girin...',
//           }
//         },
//       },
//     },
//   });

// export default i18n;

import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: 'en',
    detection: {
      order: ['navigator', 'localStorage', 'cookie', 'htmlTag'],
      caches: ['localStorage', 'cookie'],
      lookupLocalStorage: 'i18nextLng',
      lookupCookie: 'i18nextLng',
      cookieExpirationDate: new Date(Date.now() + 365 * 24 * 60 * 60 * 1000), // 1 year
      // Sadece desteklenen dilleri algıla
      checkWhitelist: true,
      whitelist: ['en', 'tr', 'ru-RU'],
      // Browser dilini daha iyi algıla
      convertDetectedLanguage: (lng) => {
        // Browser dili desteklenen dillerden birine eşleştir
        if (lng.startsWith('tr')) return 'tr';
        if (lng.startsWith('ru')) return 'ru-RU';
        return 'en'; // Varsayılan olarak İngilizce
      },
    },
    interpolation: {
      escapeValue: false,
    },
    resources: {
      en: {
        translation: {
          helpCenter: 'Help Center',
          faq: 'Frequently asked questions',
          videos: 'How-to videos',
          portal: 'Partner Portal',
          contact: 'Contact us',
          banner: {
            title: {
              line1: 'Need help?',
              line2: "We're here for",
              line3: 'you.',
            },
            subtitle: 'Search our knowledge base for answers to common questions',
            searchPlaceholder: 'Enter a search term ...',
            searchButton: 'Search',
            noResults: 'No results found for',
            popularTopics: 'Popular topics:',
            viewAllResults: 'View all results',
            topics: {
              application: 'application',
              supplierVerification: 'supplier verification',
              productLinking: 'product linking',
              options: 'options',
              productCreation: 'product creation'
            }
          },
          cards: {
            submit: 'Submit a Ticket',
            personalizedHelp: 'Get personalized help from our support team',
            videoTutorials: 'Video Tutorials',
            stepByStep: 'Watch step-by-step guides and tutorials',
            contactSupport: 'Contact Support',
            speakDirectly: 'Speak directly with our support agents',
            faq: 'FAQ',
            findAnswers: 'Find answers to frequently asked questions',
          },
          faqHeader: {
            title: 'Frequently Asked Questions',
            subtitle: 'Find answers to common questions about being a Tourzone partner',
            searchPlaceholder: 'Search frequently asked questions...',
          },
          menu: 'Menu',
          language: 'Language',
          article: {
            updated: 'Updated',
            published: 'Published',
            readingTime: 'min read',
            backToFaq: 'Back to FAQ',
            articleNotFound: 'Article Not Found',
            articleNotFoundMessage: "The article you're looking for doesn't exist or has been removed.",
            articlesInSection: 'Articles in this section',
            noOtherArticles: 'No other articles in this section',
            searchPlaceholder: 'Enter a search term',
          },
          category: {
            searchPlaceholder: 'Enter a search term and press Enter',
            commonTopics: 'Common topics:',
            noArticlesInFolder: 'No Articles in Folder',
            noArticlesInFolderMessage: 'No articles are available in the folder "{name}" at the moment.',
            noArticlesInCategoryMessage: 'No articles are available in this category at the moment.',
            backToFaq: 'Back to FAQ',
          },
          faqPage: {
            title: 'FAQs',
            subtitle: 'Search our knowledge base for answers to common questions',
            searchPlaceholder: 'Enter a search term and press Enter',
            articlesInFolder: 'articles in this folder',
            seeAllArticles: 'See all articles',
            noArticlesInFolder: 'No articles available in this folder',
            noArticlesInCategory: 'No articles available in this category',
            loadingArticles: 'Loading articles...',
            failedToLoad: 'Failed to Load FAQ',
            failedToLoadMessage: 'Unable to load FAQ categories. Please try again later.',
            retry: 'Retry',
            commonTopics: 'Common topics:',
            noResults: {
              title: 'No FAQ categories found',
              message: 'Try adjusting your search terms or browse all categories.',
            },
            articlesInCategory: 'articles in this category',
          },
          contactPage: {
            title: 'Contact Us',
            subtitle: 'Get in touch with us',
            firstName: 'First name',
            lastName: 'Last name',
            email: 'Email',
            message: 'Tell us about your needs...',
            phone: 'Phone',
            sendMessage: 'Send message',
            sending: 'Sending...',
            talkWithUs: 'Talk with us',
            callUs: 'Give us a call at',
            orMessageUs: 'Or message us on',
            officesTitle: 'Our offices around the world',
            ukOffice: 'UK & Europe',
            turkeyOffice: 'Turkey & MENA',
            ukAddress: '27 Old Gloucester Street\nLondon, WC1N3AX\nUnited Kingdom',
            turkeyAddress: 'Güzeloba Mah. Çağlayangil Cad. No:3B\nOfis No:5, Muratpaşa /Antalya\nTÜRKİYE',
            successTitle: '✅ Ticket submitted successfully!',
            successMessage: 'We\'ll get back to you within 24 hours.',
            errorMessage: 'Failed to send message. Please try again.',
            validation: {
              firstNameRequired: 'Please enter your first name',
              lastNameRequired: 'Please enter your last name',
              emailRequired: 'Please enter your email address',
              emailInvalid: 'Please enter a valid email address',
              messageRequired: 'Please enter your message',
              messageMinLength: 'Please provide more details (at least 20 characters)'
            }
          },
          searchPage: {
            title: 'Search Results',
            subtitle: 'Find articles, guides, and solutions',
            searchPlaceholder: 'Enter your search terms...',
            commonTopics: 'Common topics:',
            byCategory: 'By Category',
            sortBy: 'Sort By',
            relevance: 'Relevance',
            date: 'Date',
            views: 'Views',
            allCategories: 'All Categories',
            searching: 'Searching...',
            resultsFor: 'results for',
            in: 'in',
            noResultsFound: 'No results found for',
            tryDifferentKeywords: 'Try different keywords or check your spelling',
            searchKnowledgeBase: 'Search Our Knowledge Base',
            enterSearchTerms: 'Enter your search terms above to find articles, guides, and solutions.',
            showing: 'Showing',
            of: 'of',
            results: 'results',
            previous: 'Previous',
            next: 'Next',
            last: 'Last',
            page: 'Page',
            ofPages: 'of',
            noDescriptionAvailable: 'No description available',
            unknownDate: 'Unknown date',
            views: 'views',
            uncategorized: 'Uncategorized',
            topics: {
              accountManagement: 'Account Management',
              product: 'Product',
              bookingSupport: 'Booking Support',
              payment: 'Payment',
              sales: 'Sales',
              reports: 'Reports'
            },
            searchTerms: {
              accountManagement: 'account management',
              product: 'product',
              bookingSupport: 'booking support',
              payment: 'payment',
              sales: 'sales',
              reports: 'reports'
            }
          },
          
        },
      },
      'ru-RU': {
        translation: {
          helpCenter: 'Центр помощи партнёров',
          faq: 'Часто задаваемые вопросы',
          videos: 'Обучающие видео',
          portal: 'Портал партнёра',
          contact: 'Связаться с нами',
          banner: {
            title: {
              line1: 'Нужна помощь?',
              line2: 'Мы здесь для',
              line3: 'вас.',
            },
            subtitle: 'Ищите ответы в нашей базе знаний на часто задаваемые вопросы',
            searchPlaceholder: 'Введите поисковый запрос...',
            searchButton: 'Поиск',
            noResults: 'Результаты не найдены для',
            popularTopics: 'Популярные темы:',
            viewAllResults: 'Посмотреть все результаты',
            topics: {
              application: 'приложение',
              supplierVerification: 'верификация поставщика',
              productLinking: 'связывание продуктов',
              options: 'опции',
              productCreation: 'создание продукта'
            }
          },
          cards: {
            submit: 'Отправить заявку',
            personalizedHelp: 'Получите персональную помощь от нашей службы поддержки',
            videoTutorials: 'Видеоуроки',
            stepByStep: 'Смотрите пошаговые инструкции и учебные видео',
            contactSupport: 'Связаться со службой поддержки',
            speakDirectly: 'Поговорите напрямую с нашими агентами поддержки',
            faq: 'Часто задаваемые вопросы',
            findAnswers: 'Найдите ответы на часто задаваемые вопросы',
          },
          faqHeader: {
            title: 'Часто задаваемые вопросы',
            subtitle: 'Ответы на часто задаваемые вопросы о партнёрстве с Tourzone',
            searchPlaceholder: 'Поиск часто задаваемых вопросов...',
          },
          menu: 'Меню',
          language: 'Язык',
          article: {
            updated: 'Обновлено',
            published: 'Опубликовано',
            readingTime: 'мин чтения',
            backToFaq: 'Назад к FAQ',
            articleNotFound: 'Статья не найдена',
            articleNotFoundMessage: 'Статья, которую вы ищете, не существует или была удалена.',
            articlesInSection: 'Статьи в этом разделе',
            noOtherArticles: 'Других статей в этом разделе нет',
            searchPlaceholder: 'Введите поисковый запрос',
          },
          category: {
            searchPlaceholder: 'Введите поисковый запрос и нажмите Enter',
            commonTopics: 'Популярные темы:',
            noArticlesInFolder: 'Статей в папке нет',
            noArticlesInFolderMessage: 'В папке "{name}" пока нет доступных статей.',
            noArticlesInCategoryMessage: 'В этой категории пока нет доступных статей.',
            backToFaq: 'Назад к FAQ',
          },
          faqPage: {
            title: 'Часто задаваемые вопросы',
            subtitle: 'Ищите ответы в нашей базе знаний',
            searchPlaceholder: 'Введите поисковый запрос и нажмите Enter',
            articlesInFolder: 'статей в этой папке',
            seeAllArticles: 'Посмотреть все статьи',
            noArticlesInFolder: 'В этой папке нет статей',
            noArticlesInCategory: 'В этой категории нет статей',
            loadingArticles: 'Загрузка статей...',
            failedToLoad: 'Не удалось загрузить FAQ',
            failedToLoadMessage: 'Не удалось загрузить категории FAQ. Попробуйте позже.',
            retry: 'Повторить',
            commonTopics: 'Популярные темы:',
            noResults: {
              title: 'Категории FAQ не найдены',
              message: 'Попробуйте изменить поисковые запросы или просмотрите все категории.',
            },
            articlesInCategory: 'статей в этой категории',
          },
          contactPage: {
            title: 'Связаться с нами',
            subtitle: 'Свяжитесь с нами',
            firstName: 'Имя',
            lastName: 'Фамилия',
            email: 'Электронная почта',
            message: 'Расскажите нам о ваших потребностях...',
            phone: 'Телефон',
            sendMessage: 'Отправить сообщение',
            sending: 'Отправка...',
            talkWithUs: 'Поговорите с нами',
            callUs: 'Позвоните нам по номеру',
            orMessageUs: 'Или напишите нам в',
            officesTitle: 'Наши офисы по всему миру',
            ukOffice: 'Великобритания и Европа',
            turkeyOffice: 'Турция и Ближний Восток',
            ukAddress: '27 Old Gloucester Street\nЛондон, WC1N3AX\nВеликобритания',
            turkeyAddress: 'Güzeloba Mah. Çağlayangil Cad. No:3B\nOfis No:5, Muratpaşa /Antalya\nТУРЦИЯ',
            successTitle: '✅ Заявка успешно отправлена!',
            successMessage: 'Мы свяжемся с вами в течение 24 часов.',
            errorMessage: 'Не удалось отправить сообщение. Попробуйте еще раз.',
            validation: {
              firstNameRequired: 'Пожалуйста, введите ваше имя',
              lastNameRequired: 'Пожалуйста, введите вашу фамилию',
              emailRequired: 'Пожалуйста, введите ваш email',
              emailInvalid: 'Пожалуйста, введите корректный email',
              messageRequired: 'Пожалуйста, введите ваше сообщение',
              messageMinLength: 'Пожалуйста, предоставьте более подробную информацию (минимум 20 символов)'
            }
          },
          searchPage: {
            title: 'Результаты поиска',
            subtitle: 'Найдите статьи, руководства и решения',
            searchPlaceholder: 'Введите поисковые запросы...',
            commonTopics: 'Популярные темы:',
            byCategory: 'По категориям',
            sortBy: 'Сортировать по',
            relevance: 'Релевантность',
            date: 'Дата',
            views: 'Просмотры',
            allCategories: 'Все категории',
            searching: 'Поиск...',
            resultsFor: 'результатов для',
            in: 'в',
            noResultsFound: 'Результаты не найдены для',
            tryDifferentKeywords: 'Попробуйте другие ключевые слова или проверьте правописание',
            searchKnowledgeBase: 'Поиск в базе знаний',
            enterSearchTerms: 'Введите поисковые запросы выше, чтобы найти статьи, руководства и решения.',
            showing: 'Показано',
            of: 'из',
            results: 'результатов',
            previous: 'Предыдущая',
            next: 'Следующая',
            last: 'Последняя',
            page: 'Страница',
            ofPages: 'из',
            noDescriptionAvailable: 'Описание недоступно',
            unknownDate: 'Неизвестная дата',
            views: 'просмотров',
            uncategorized: 'Без категории',
            topics: {
              accountManagement: 'Управление аккаунтом',
              product: 'Продукт',
              bookingSupport: 'Поддержка бронирования',
              payment: 'Оплата',
              sales: 'Продажи',
              reports: 'Отчеты'
            },
            searchTerms: {
              accountManagement: 'управление аккаунтом',
              product: 'продукт',
              bookingSupport: 'поддержка бронирования',
              payment: 'оплата',
              sales: 'продажи',
              reports: 'отчеты'
            }
          },
          
        },
      },
      tr: {
        translation: {
          helpCenter: 'Yardım Merkezi',
          faq: 'Sıkça Sorulan Sorular',
          videos: 'Nasıl Yapılır Videoları',
          portal: 'İş Ortağı Portalı',
          contact: 'Bizimle İletişime Geçin',
          banner: {
            title: {
              line1: 'Yardıma mı ihtiyacınız var?',
              line2: 'Sizin için',
              line3: 'buradayız.',
            },
            subtitle: 'Sıkça sorulan sorulara yanıtlar için bilgi tabanımızda arayın',
            searchPlaceholder: 'Bir arama terimi girin...',
            searchButton: 'Ara',
            noResults: 'Sonuç bulunamadı',
            popularTopics: 'Yaygın konular:',
            viewAllResults: 'Tüm sonuçları gör',
            topics: {
              application: 'uygulama',
              supplierVerification: 'tedarikçi doğrulanması',
              productLinking: 'ürün bağlama',
              options: 'seçenekler',
              productCreation: 'ürün oluşturma'
            }
          },
          cards: {
            submit: 'Destek Talebi Oluştur',
            personalizedHelp: 'Destek ekibimizden kişiselleştirilmiş yardım alın',
            videoTutorials: 'Video Eğitimleri',
            stepByStep: 'Adım adım kılavuzları ve eğitim videolarını izleyin',
            contactSupport: 'Destekle İletişime Geçin',
            speakDirectly: 'Destek temsilcilerimizle doğrudan konuşun',
            faq: 'SSS',
            findAnswers: 'Sıkça sorulan sorulara yanıt bulun',
          },
          faqHeader: {
            title: 'Sıkça Sorulan Sorular',
            subtitle: 'Tourzone iş ortağı olma hakkında sıkça sorulan soruların yanıtlarını bulun',
            searchPlaceholder: 'Sıkça sorulan soruları arayın...',
          },
          menu: 'Menü',
          language: 'Dil',
          article: {
            updated: 'Şu tarihte değiştirildi',
            published: 'Yayınlandı',
            readingTime: 'dakika okuma',
            backToFaq: 'SSS\'ye Geri Dön',
            articleNotFound: 'Makale Bulunamadı',
            articleNotFoundMessage: 'Aradığınız makale mevcut değil veya kaldırılmış.',
            articlesInSection: 'Bu bölümdeki makaleler',
            noOtherArticles: 'Bu bölümde başka makale yok',
            searchPlaceholder: 'Bir arama terimi girin',
          },
          category: {
            searchPlaceholder: 'Bir arama terimi girin ve Enter\'a basın',
            commonTopics: 'Yaygın konular:',
            noArticlesInFolder: 'Klasörde Makale Yok',
            noArticlesInFolderMessage: '"{name}" klasöründe şu anda makale bulunmuyor.',
            noArticlesInCategoryMessage: 'Bu kategoride şu anda makale bulunmuyor.',
            backToFaq: 'SSS\'ye Geri Dön',
          },
          faqPage: {
            title: 'SSS',
            subtitle: 'Sıkça sorulan sorulara yanıtlar için bilgi tabanımızda arayın',
            searchPlaceholder: 'Bir arama terimi girin ve Enter\'a basın',
            articlesInFolder: 'makale bu klasörde',
            seeAllArticles: 'Tüm makaleleri görüntüle',
            noArticlesInFolder: 'Bu klasörde makale bulunmuyor',
            noArticlesInCategory: 'Bu kategoride makale bulunmuyor',
            loadingArticles: 'Makaleler yükleniyor...',
            failedToLoad: 'SSS Yüklenemedi',
            failedToLoadMessage: 'SSS kategorileri yüklenemedi. Lütfen daha sonra tekrar deneyin.',
            retry: 'Tekrar Dene',
            commonTopics: 'Yaygın konular:',
            noResults: {
              title: 'SSS kategorileri bulunamadı',
              message: 'Arama terimlerinizi ayarlamayı deneyin veya tüm kategorileri gözden geçirin.',
            },
            articlesInCategory: 'makale bu kategoride',
          },
          contactPage: {
            title: 'Bizimle İletişime Geçin',
            subtitle: 'Bizimle iletişime geçin',
            firstName: 'Ad',
            lastName: 'Soyad',
            email: 'E-posta',
            message: 'İhtiyaçlarınız hakkında bize bilgi verin...',
            phone: 'Telefon',
            sendMessage: 'Mesaj gönder',
            sending: 'Gönderiliyor...',
            talkWithUs: 'Bizimle konuşun',
            callUs: 'Bizi arayın',
            orMessageUs: 'Veya bize mesaj gönderin',
            officesTitle: 'Dünya genelindeki ofislerimiz',
            ukOffice: 'İngiltere ve Avrupa',
            turkeyOffice: 'Türkiye',
            ukAddress: '27 Old Gloucester Street\nLondra, WC1N3AX\nBirleşik Krallık',
            turkeyAddress: 'Güzeloba Mah. Çağlayangil Cad. No:3B\nOfis No:5, Muratpaşa /Antalya\nTÜRKİYE',
            successTitle: '✅ Destek talebi başarıyla gönderildi!',
            successMessage: '24 saat içinde size geri döneceğiz.',
            errorMessage: 'Mesaj gönderilemedi. Lütfen tekrar deneyin.',
            validation: {
              firstNameRequired: 'Lütfen adınızı girin',
              lastNameRequired: 'Lütfen soyadınızı girin',
              emailRequired: 'Lütfen e-posta adresinizi girin',
              emailInvalid: 'Lütfen geçerli bir e-posta adresi girin',
              messageRequired: 'Lütfen mesajınızı girin',
              messageMinLength: 'Lütfen daha detaylı bilgi verin (en az 20 karakter)'
            }
          },
          searchPage: {
            title: 'Arama Sonuçları',
            subtitle: 'Makaleler, kılavuzlar ve çözümler bulun',
            searchPlaceholder: 'Arama terimlerinizi girin...',
            commonTopics: 'Yaygın konular:',
            byCategory: 'Kategoriye Göre',
            sortBy: 'Sırala',
            relevance: 'İlgi',
            date: 'Tarih',
            views: 'Görüntüleme',
            allCategories: 'Tüm Kategoriler',
            searching: 'Aranıyor...',
            resultsFor: 'sonuç',
            in: 'içinde',
            noResultsFound: 'Sonuç bulunamadı',
            tryDifferentKeywords: 'Farklı anahtar kelimeler deneyin veya yazımınızı kontrol edin',
            searchKnowledgeBase: 'Bilgi Tabanımızda Arayın',
            enterSearchTerms: 'Makaleler, kılavuzlar ve çözümler bulmak için yukarıdaki arama terimlerinizi girin.',
            showing: 'Gösteriliyor',
            of: '/',
            results: 'sonuç',
            previous: 'Önceki',
            next: 'Sonraki',
            last: 'Son',
            page: 'Sayfa',
            ofPages: '/',
            noDescriptionAvailable: 'Açıklama mevcut değil',
            unknownDate: 'Bilinmeyen tarih',
            views: 'görüntüleme',
            uncategorized: 'Kategorisiz',
            topics: {
              accountManagement: 'Hesap Yönetimi',
              product: 'Ürün',
              bookingSupport: 'Rezervasyon Desteği',
              payment: 'Ödeme',
              sales: 'Satış',
              reports: 'Raporlar'
            },
            searchTerms: {
              accountManagement: 'hesap yönetimi',
              product: 'ürün',
              bookingSupport: 'rezervasyon desteği',
              payment: 'ödeme',
              sales: 'satış',
              reports: 'raporlar'
            }
          },
          
        },
      },
    },
  });

export default i18n;
